<template>
  <a href="javaScropt:" @click="backTop" class="allgoTop" v-if="btnFlag">
    <img src="~img/book/top.svg" alt="" />
  </a>
</template>

<script>
export default {
  data() {
    return {
      btnFlag: false //顶部
    };
  },
  methods: {
    // 点击图片回到顶部方法，加计时器是为了过渡顺滑
    backTop() {
      const that = this;
      let timer = setInterval(() => {
        let ispeed = Math.floor(-that.scrollTop / 5);
        document.documentElement.scrollTop = document.body.scrollTop =
          that.scrollTop + ispeed;
        if (that.scrollTop === 0) {
          clearInterval(timer);
        }
      }, 16);
    }
  }
};
</script>

<style lang="stylus">
.allgoTop
    position fixed
    bottom 210px
    right 50px
    width 30px
    img
        width 100%
</style>
